import timezone from "dayjs/plugin/timezone.js";
import utc from "dayjs/plugin/utc.js";
import dayjs from "dayjs";
dayjs.extend(utc);
dayjs.extend(timezone);
export const utcNow = () => dayjs().utc();
export class SpanTracker {
    maxAge = 30_000;
    activeTraces = [];
    spanMap = new Map();
    oldest = 0;
    constructor(opts) {
        if (typeof opts?.maxAge === "number")
            this.maxAge = opts.maxAge;
    }
    enter(span, track) {
        this.activeTraces.push(span);
        if (track)
            this.spanMap.set(span.id, track);
        this.prune();
    }
    exit(span) {
        const s = this.spanMap.get(span.id);
        this.spanMap.delete(span.id);
        this.activeTraces = this.activeTraces.filter((s) => s.id !== span.id);
        this.prune();
        return s;
    }
    get active() {
        return this.activeTraces;
    }
    prune() {
        const now = utcNow().valueOf();
        if (this.oldest + this.maxAge >= now)
            return;
        this.oldest = now;
        const current = [...this.activeTraces];
        this.activeTraces = [];
        for (const span of current) {
            if (span.timestamp + this.maxAge < now)
                this.spanMap.delete(span.id);
            else
                this.activeTraces.push(span);
            this.oldest = Math.min(this.oldest, span.timestamp);
        }
    }
}
//# sourceMappingURL=util.js.map